
export default {
    methods: {
        typeColor(type){
            var colors = {
                'Lift': 'red',
                'Truck': 'lys-turkis',
                'Teleskoptruck': 'mork-turkis'
            }
            if (!(type in colors))
                return 'blue-grey';
            return colors[type];
        },
        courseColor(course){
            return this.typeColor(course.type.split(" - ")[1]);
        }
    }
}
